import loadAttachmentPolicyInfoBars from './loadAttachmentPolicyInfoBars';
import findComposeViewStateById, { IdSource } from '../utils/findComposeViewStateById';
import triggerAttachmentsChanged from '../utils/triggerAttachmentsChanged';
import {
    AttachmentStatusEnum,
    getComposeHostItemIndex,
    lazyOnNewAttachmentOnMessageCompose,
} from 'owa-addins-core';
import { onAttachmentCreated } from 'owa-attachment-well-data';
import { orchestrator } from 'satcheljs';
import { isFeatureEnabled } from 'owa-feature-flags';

orchestrator(onAttachmentCreated, actionMessage => {
    const composeViewState = findComposeViewStateById(
        actionMessage.attachmentId,
        IdSource.Attachment
    );
    if (composeViewState) {
        loadAttachmentPolicyInfoBars(composeViewState);

        // Trigger AttachmentsChanged event for any OWA addins."
        triggerAttachmentsChanged(
            composeViewState.composeId,
            AttachmentStatusEnum.Added,
            actionMessage.attachment
        );

        if (isFeatureEnabled('addin-autoRunAddins')) {
            const hostItemIndex = getComposeHostItemIndex(composeViewState.composeId);
            lazyOnNewAttachmentOnMessageCompose.importAndExecute(hostItemIndex);
        }
    }
});
